<template>
  <div class="page-container stream-info">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.orderNumber')">
            <el-input
              v-model="form.orderId"
              :placeholder="$t('text.orderNumber')"
              style="width: 260px"
              maxlength="50"></el-input>
          </el-form-item>

          <el-form-item
            v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()"
            :label="$t('text.merchantName')"
          >
            <el-select
              v-model="form.appId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="form-item-start-of-balance-version" :label="$t('text.startOfBalanceVersion')">
            <el-input
              v-model="form.balanceVersionStart"
              :placeholder="$t('text.startOfBalanceVersion')"
              style="width: 120px"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item-end-of-balance-version" :label="$t('text.endOfBalanceVersion')">
            <el-input
              v-model="form.balanceVersionEnd"
              :placeholder="$t('text.endOfBalanceVersion')"
              style="width: 120px"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.transactionType')">
            <el-select
              v-model="form.transType"
              filterable
              :placeholder="$t('message.chooseOne')"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('transactionType.11')" value="11"></el-option>
              <el-option :label="$t('transactionType.10')" value="10"></el-option>
              <el-option :label="$t('transactionType.12')" value="12"></el-option>
              <el-option :label="$t('transactionType.21')" value="21"></el-option>
              <el-option :label="$t('transactionType.22')" value="22"></el-option>
              <el-option :label="$t('transactionType.20')" value="20"></el-option>
              <el-option :label="$t('transactionType.23')" value="23"></el-option>
              <el-option :label="$t('text.rechargeSuccess')" value="31"></el-option>
              <el-option :label="$t('transactionType.30')" value="30"></el-option>
              <el-option :label="$t('transactionType.40')" value="40"></el-option>
              <el-option :label="$t('transactionType.50')" value="50"></el-option>
              <el-option :label="$t('text.agentWithdrawal')" value="51"></el-option>
              <el-option :label="$t('transactionType.61')" value="61"></el-option>
              <el-option :label="$t('transactionType.62')" value="62"></el-option>
              <el-option :label="$t('transactionType.33')" value="33"></el-option>
              <el-option :label="$t('transactionType.32')" value="32"></el-option>
              <el-option :label="$t('transactionType.70')" value="70"></el-option>
              <el-option :label="$t('transactionType.71')" value="71"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.debitOrCredit')">
            <el-select
              v-model="form.balanceTrend"
              filterable
              :placeholder="$t('message.chooseOne')"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('balanceTrend.1')" value="1"></el-option>
              <el-option :label="$t('balanceTrend.-1')" value="-1"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item :label="$t('text.businessHours')">
                <el-date-picker
                        v-model="timeDate"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyyMMdd"
                        :range-separator="$t('text.to')"
                        :start-placeholder="$t('text.startDate')"
                        :end-placeholder="$t('text.endDate')"
                        @change="timeChange"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('text.transactionTime')">
                <el-date-picker
                        v-model="createDateRange"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyyMMdd"
                        :range-separator="$t('text.to')"
                        :start-placeholder="$t('text.startDate')"
                        :end-placeholder="$t('text.endDate')"
                        @change="createTimeChange"
                >
                </el-date-picker>
            </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button
            :loading="loading"
            type="primary"
            @click="exportDetail"
            size="small"
            v-if="!ROLE_TYPE.isBusinessCustomerServiceManage()"
          >
            {{ $t('text.export') }}</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column
            width="180px"
            prop="appId"
            :label="$t('text.appId')"
            align="center"
          ></el-table-column>

          <el-table-column
            width="180px"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
          ></el-table-column>

          <el-table-column
              width="300px"
              prop="merchantOrderId"
              :label="$t('text.merchantOrderId')"
              align="center"
          ></el-table-column>

          <el-table-column
            width="150px"
            prop="bizTimeStr"
            :label="$t('text.businessHours')"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="transType"
            :label="$t('text.transactionType')"
            width="90px"
            :formatter="$formatter.formatTransType"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                size="small"
                :type="
                  row.transType === '20' ||
                  row.transType === '21' ||
                  row.transType === '22'
                    ? 'warning'
                    : row.transType === '11' || row.transType === '10'
                    ? 'success'
                    : 'primary'
                "
                >{{
                  $formatter.formatTransType(null, null, row.transType, null)
                }}</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="orderAmount"
            :formatter="$formatter.FenToYuan3ToThousandth"
            width="140px"
            :label="$t('text.transactionAmount')"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="actualAmount"
            :formatter="$formatter.FenToYuan3ToThousandth"
            width="140px"
            :label="$t('text.changeAmount')"
            align="center"
          ></el-table-column>

          <el-table-column
            width="90px"
            prop="balanceTrend"
            :label="$t('text.changeType')"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.balanceTrend === '1'" type="success" size="mini"
                >{{ $t('balanceTrend.1') }}</el-tag
              >
              <el-tag v-else type="danger" size="mini">{{ $t('balanceTrend.-1') }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="currentBalanceStr"
            width="140px"
            :label="$t('text.afterBalance')"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="balanceVersion"
            width="120px"
            :label="$t('text.balanceVersion')"
            align="center"
          ></el-table-column>

          <el-table-column width="80" prop="remark" :label="$t('text.remark')" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.remark">
                <el-popover
                  v-if="row.remark && row.remark.length > 10"
                  placement="top-start"
                  width="80"
                  trigger="hover"
                  :content="row.remark"
                >
                  <div slot="reference" class="remark">
                    {{ row.remark }}
                  </div>
                </el-popover>
                <div v-else>{{ row.remark }}</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            width="170px"
            prop="transactionId"
            :label="$t('text.transactionSn')"
            align="center"
          ></el-table-column>

          <el-table-column
            width="150px"
            prop="createTimeStr"
            :label="$t('text.creationTime')"
            align="center"
          ></el-table-column>

          <el-table-column
            width="350px"
            prop="tradeId"
            :label="$t('text.traceId')"
            align="center"
          ></el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import moment from 'moment'
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },components: {
    page: Page,
  },
  data() {
    return {
      url: '/transactionFlow/selectList',
      merchantList: [],
      form: {
          appId: '',
          startDate: '',
          endDate: '',
          createDateRangeStart: '',
          createDateRangeEnd: '',
          tradeOrderId: '',
          balanceVersionStart: "",
          balanceVersionEnd: "",
      },
        timeDate: [],
        createDateRange: [],
        loading: false,
    }
  },
  methods: {
      timeChange(e) {
          if (e) {
              this.form.startDate = e[0]
              this.form.endDate = e[1]
          } else {
              this.form.startDate = ''
              this.form.endDate = ''
          }
      },
      createTimeChange(e) {
          if (e) {
              this.form.createDateRangeStart = e[0]
              this.form.createDateRangeEnd = e[1]
          } else {
              this.form.createDateRangeStart = ''
              this.form.createDateRangeEnd = ''
          }
      },
      reset() {
          let start = moment().subtract(2, 'days').format('yyyyMMDD')
          let end = moment().format('yyyyMMDD')
          this.form.startDate = start
          this.form.endDate = end
          this.timeDate = [start, end]

          let createDateStart = moment().format('yyyyMMDD');
          this.form.createDateRangeStart = createDateStart;
          this.form.createDateRangeEnd = end;
          this.createDateRange = [createDateStart, end]
      },
    exportDetail() {
      this.loading = true
      this.axios
        .get('/transactionFlow/selectListForExport', {
          params: this.form,
          responseType: 'blob'
        })
        .then(res => {
          if (res.data) { // 回excel資料，瀏覽器下載
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.$t('text.fundReport.xlsx'));
            document.body.appendChild(link);
            link.click();
          } else if (res.text) { // 回JSON，開彈窗
            res.text().then(JSON.parse).then(res => {
              if (res.code !== 200) {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              } else {
                this.$message({
                  message: res.msg,
                  type: 'success',
                })
              }
            })
          }
        })
        this.loading = false
    },
 
  },

  created() {
      let start = moment().subtract(2, 'days').format('yyyyMMDD')
      let end = moment().format('yyyyMMDD')
      this.form.startDate = start
      this.form.endDate = end
      this.timeDate = [start, end]

      let createDateStart = moment().format('yyyyMMDD');
      this.form.createDateRangeStart = createDateStart;
      this.form.createDateRangeEnd = end;
      this.createDateRange = [createDateStart, end]

      this.$axios
          .get('/merchant/selectListForOption', {params: {}})
          .then(res => {
              this.merchantList = res.data
              // if (this.merchantList.length == 1) {
              // this.form.appId = this.merchantList[0].value
              // this.$bus.$emit('refresh')
              // }
          })
  },
}
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.el-form-item {
  margin-bottom: 20px;
}
</style>